// components/projects/ProjectDetailSkeleton.tsx
import React from "react";

const ProjectDetailSkeleton: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 animate-pulse">
      {/* Back Button Skeleton */}
      <div className="h-6 w-32 bg-gray-200 rounded-lg mb-6" />

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Main Content Skeleton */}
        <div className="lg:col-span-2 space-y-6">
          {/* Header Card Skeleton */}
          <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6">
            <div className="flex flex-wrap items-start justify-between gap-4 mb-4">
              <div>
                <div className="h-6 w-24 bg-gray-200 rounded-full mb-3" />
                <div className="h-8 w-64 bg-gray-200 rounded-lg" />
              </div>
              <div className="text-right">
                <div className="h-10 w-20 bg-gray-200 rounded-lg mb-1" />
                <div className="h-4 w-16 bg-gray-200 rounded-lg" />
              </div>
            </div>

            <div className="h-4 w-full bg-gray-200 rounded-lg mb-2" />
            <div className="h-4 w-full bg-gray-200 rounded-lg mb-2" />
            <div className="h-4 w-3/4 bg-gray-200 rounded-lg mb-6" />

            <div className="flex flex-wrap gap-4">
              {[1, 2, 3].map((i) => (
                <div key={i} className="h-10 w-32 bg-gray-200 rounded-lg" />
              ))}
            </div>
          </div>

          {/* Responsibilities Skeleton */}
          <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6">
            <div className="h-6 w-40 bg-gray-200 rounded-lg mb-4" />
            <div className="space-y-3">
              {[1, 2, 3, 4, 5].map((i) => (
                <div key={i} className="flex items-start gap-3">
                  <div className="w-5 h-5 rounded-full bg-gray-200" />
                  <div className="h-4 flex-1 bg-gray-200 rounded-lg" />
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Sidebar Skeleton */}
        <div className="space-y-6">
          <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6">
            <div className="h-6 w-32 bg-gray-200 rounded-lg mb-4" />

            <div className="mb-6">
              <div className="h-4 w-24 bg-gray-200 rounded-lg mb-2" />
              <div className="flex flex-wrap gap-2">
                {[1, 2, 3, 4].map((i) => (
                  <div key={i} className="h-7 w-20 bg-gray-200 rounded-lg" />
                ))}
              </div>
            </div>

            <div className="mb-6 p-4 bg-gray-50 rounded-xl">
              <div className="flex items-center justify-between mb-2">
                <div className="h-4 w-24 bg-gray-200 rounded-lg" />
                <div className="h-4 w-16 bg-gray-200 rounded-lg" />
              </div>
              <div className="h-2 bg-gray-200 rounded-full" />
            </div>

            <div className="h-14 w-full bg-gray-200 rounded-xl" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectDetailSkeleton;
